import { Injectable } from '@angular/core';
import { BaseAppService } from 'vpo-shared';

@Injectable({
  providedIn: 'root',
})
export class AppService extends BaseAppService {
  private _izvoziLabel = 'Izvozi v Excel';
  private _izvoziIcon = 'fas fa-file-excel';

  public get izvoziLabel() {
    return this._izvoziLabel;
  }

  public get izvoziIcon() {
    return this._izvoziIcon;
  }

  constructor() {
    super();

    this.version = '1.13.0';
  }
}
